<template>
    <div class="body">
        <div class="box1">
            <div class="box1-1">
                <span class="box-title">订单进度</span>
                <span class="red">待支付</span>
            </div>
            <div class="box1-2">
                <div>
                    <span class="box-title">账单号</span>
                    <span>{{ orderDetail.studentBillDetailId }}</span>
                </div>
                <div>
                    <span class="box-title">出账日期</span>
                    <span>{{ orderDetail.createTime }}</span>
                </div>
                <div>
                    <span class="box-title">缴费截止日期</span>
                    <span>{{ orderDetail.endTime }}</span>
                </div>
                <div>
                    <span class="box-title">姓名</span>
                    <span>{{ studentName }}</span>
                </div>
                <div>
                    <span class="box-title">备注说明</span>
                    <span>{{ orderDetail.remark }}</span>
                </div>
                <div v-if="orderDetail.stable">
                    <span class="box-title"></span>
                    <span>{{ orderDetail.stable }}</span>
                </div>
            </div>
            <div class="box1-3">
                <span class="box-title">合计</span>
                <span class="black">￥{{ orderDetail.payableAmount }}</span>
            </div>
            <div class="box1-3">
                <span class="box-title">累计缴费</span>
                <span class="price green">￥{{ orderDetail.payedAmount }}</span>
            </div>
            <div class="box1-3" v-if="orderDetail.refundedAmount">
                <span class="box-title">累计退费</span>
                <span class="black">￥{{ orderDetail.refundedAmount }}</span>
            </div>
            <div class="box1-3" v-if="orderDetail.unpaidAmount">
                <span class="box-title">应缴金额</span>
                <span class="price">￥{{ orderDetail.unpaidAmount }}</span>
            </div>
        </div>
        <div class="box2" v-if="orderDetail.commonCommodities">
            <div class="box2-2" v-for="(item, index) in orderDetail.commonCommodities" :key="index">
                <div class="name">{{ item.commodityName }}</div>
                <div class="user">{{ orderDetail.className }} {{ orderDetail.studentName }}</div>
                <div class="price1">
                    <span>￥{{ item.sellingPrice }}</span>
                    <span class="num">x1</span>
                </div>
            </div>
        </div>

        <div class="qrCodeError" v-if="qrCodeErrorMessage">
            付款二维码生成失败，原因：{{ qrCodeErrorMessage }}
        </div>

        <div class="codeBody">
            <div v-loading="imgLoading">
                <img :src="codeUrl" class="codeBox">
            </div>
            <div>
                <!--<p class="p1">-->
                <!--<span class="num1">￥{{orderDetail.payableAmount}}</span>-->
                <!--<span class="num2">已付  <span class="green">￥{{orderDetail.payedAmount}}</span></span>-->
                <!--</p>
                -->
                <p class="p1">
                    <span class="num1Tip">二维码金额：</span>
                    <span class="num1">￥{{ codeAmount }}</span>
                </p>
                <p class="p2">
                    <img :src="require('../../assets/imgs/nonghang.png')" class="bankIcon" />
                    <van-icon name="alipay" color="#3894FF" size="20" />
                    <van-icon name="wechat-pay" color="#34D72B" size="20" />
                    <span>扫码支付</span>
                </p>
                <p class="p3">
                    支付后，请登录农行掌银查看详情
                </p>
                <p class="p4" v-if="orderDetail.reductionPolicy && orderDetail.reductionPolicy.channels && orderDetail.reductionPolicy.channels.includes('农行掌银')">
                    （农行掌银扫码支付，{{ orderDetail.reductionPolicy.displayText }}）  
                </p>
                 <p class="p4" v-if="orderDetail.reductionPolicy && orderDetail.reductionPolicy.channels && orderDetail.reductionPolicy.channels.includes('微信支付')">
                    （微信扫码支付，{{ orderDetail.reductionPolicy.displayText }}）  
                </p>
            </div>
        </div>


        <!--<div class="btns">-->
        <!--<el-button type="success" class="btn" @click="getRefresh()">二维码刷新</el-button>-->
        <!--</div>-->
        <div class="tip">
            警告：如果扫码缴费时提示异常，可以点击 <span class="refresh" @click="getRefresh()">这里</span> 生成新的账单缴费码。
            一旦新的缴费码生成，严禁继续扫之前的缴费码支付。
        </div>

        <div v-if="orderDetail.ctnTrue > 1" class="btnsDiv">
            <van-button color="#49B78B" size="large" @click="partOrderClick" class="btn1">
                多次缴费
            </van-button>
        </div>


        <van-popup v-model="showPart" round class="partProup">
            <div class="partTitle">多次缴费
                <span class="tip">剩余次数（{{ orderDetail.ctnTrue }}）</span>
            </div>
            <div class="partContent">
                <van-field label="缴费" type="number" v-model="partPrice" class="field" maxlength="10" :border="false"
                    placeholder="请输入金额" />
            </div>

            <div class="partBtns">
                <div class="partBtn" @click="partOrderClose">取消</div>
                <div class="partBtn" @click="partOrderAdd">确定</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Notify } from 'vant';
import QRCode from 'qrcode';


export default {
    name: "studentBillDetail",

    data() {
        return {
            orderDetail: {},
            codeUrl: '',
            timer: '',
            imgLoading: false,
            studentName: '',
            qrCodeErrorMessage: '',
            qrCode: '',

            showPart: false,
            partPrice: '',
            orderCenterId: '',
            codeAmount: '',

        }
    },
    created() {
        this.orderDetail = this.$route.params.detail || {}
        this.studentName = this.$route.params.studentName || ''
        let orderCenters = this.orderDetail.orderCenters || []
        let qrCodeObj = orderCenters[0] || {}
        let qrCode = qrCodeObj.qrCode || ''
        this.qrCode = qrCode
        this.qrCodeErrorMessage = this.orderDetail.qrCodeErrorMessage
        this.orderCenterId = this.orderDetail.orderCenters[0].orderCenterId || ''
        this.start()


        this.code = this.$route.query.code
        console.log(this.code, this.$route.query, 1)
    },
    mounted() {
        this.getUrl()
    },
    computed: {
        // showDiscount() {
        //     let discountSchoolIds = ['5040929423523841', '5040935616970753', '5040940548227073', '5040944657661953']
        //     let schoolId = this.orderDetail && this.orderDetail.schoolId ? String(this.orderDetail.schoolId) : ''
        //     return discountSchoolIds.indexOf(schoolId) > -1
        // }
    },
    methods: {
        async getUrl() {
            try {
                this.codeUrl = await QRCode.toDataURL(this.qrCode);
                console.log(this.codeUrl, 2)
            } catch (err) {
                console.error('生成二维码失败:', err);
            }
        },

        getResult() {
            let _this = this
            let url = '/zuhu1/api-dashboard/studentBill/result2'
            let query = {
                studentBillDetailId: this.orderDetail.studentBillDetailId,
                orderCenterId: this.orderCenterId
            }
            this.$api.post(url, query, function (result) {
                let datas = result.data.data || []
                let obj = datas[0] || {}
                let payStatus = obj.payStatus
                _this.codeAmount = obj.amount
                if (payStatus == 1) {
                    _this.$router.push({
                        name: 'billPaySuccess',
                        query: { amount: obj.amount, thirdOrderNo: obj.thirdOrderNo, successTime: obj.successTime, }
                    })
                }
            })
        },
        start() {
            let orderCenters = this.orderDetail.orderCenters || []
            if (orderCenters.length > 0) {
                this.getResult()
                this.timer = setInterval(this.getResult, 2000);
            }
        },

        getRefresh() {
            let _this = this
            let url = '/zuhu1/api-dashboard/studentBill/refresh'
            let query = {
                studentBillDetailId: this.orderDetail.studentBillDetailId
            }
            this.imgLoading = true
            this.$api.post(url, query, function (result) {
                let datas = result.data.data || {}
                let qrCode = datas.qrCode
                _this.orderCenterId = datas.orderCenterId
                _this.qrCode = qrCode
                _this.getUrl()
                _this.imgLoading = false
                if (result.data.code == 'FAILURE') {
                    _this.qrCodeErrorMessage = result.data.message
                }
            })
        },
        partOrderClick() {
            this.showPart = true
        },
        partOrderClose() {
            this.showPart = false
            this.partPrice = ''
        },
        partOrderAdd() {
            let _this = this
            if (!_this.partPrice) {
                Notify({ type: 'warning', message: '请输入缴费金额！' });
                return
            }
            if (_this.orderDetail.payedCnt >= _this.orderDetail.cnt) {
                Notify({ type: 'warning', message: '超过最大缴费次数' });
                return
            }

            let parice = (_this.orderDetail.payableAmount - _this.orderDetail.payedAmount + _this.orderDetail.refundedAmount).toFixed(2)

            console.log(parice * 1, _this.partPrice * 1)
            if (_this.partPrice * 1 > parice * 1) {
                Notify({ type: 'warning', message: '请输入正确缴费金额！' });
                return
            }

            let url = '/zuhu1/api-dashboard/studentBill/multiple'
            let query = {
                studentBillDetailId: this.orderDetail.studentBillDetailId,
                amt: _this.partPrice
            }
            this.imgLoading = true
            this.$api.post(url, query, function (result) {
                _this.partOrderClose()
                let datas = result.data.data || {}
                let qrCode = datas.qrCode
                _this.orderCenterId = datas.orderCenterId
                _this.qrCode = qrCode
                _this.getUrl()
                _this.imgLoading = false
                _this.getResult()
                if (result.data.code == 'FAILURE') {
                    _this.qrCodeErrorMessage = result.data.message
                }
                if (qrCode) {
                    Notify({ type: 'success', message: '缴费二维码已刷新！' });
                }

            })


        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
}
</script>

<style scoped>
.body {
    font-size: 16px;
    /*background: white;*/
    width: 100%;
    height: 100%;
}

.box1 {
    background: white;
    padding: 10px 20px;
}

.box1 span {
    display: inline-block;
    padding: 0 10px;
    color: #9A9A9A;
}

.box-title {
    color: #101010 !important;
    width: 100px;
    text-align: right;
}

.box1-1 {
    border-bottom: 1px solid #BBBBBB;
    height: 40px;
    line-height: 40px;
}

.box1-2 {
    border-bottom: 1px solid #BBBBBB;
    padding: 5px 0;
}

.box1-2>div {
    min-height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: wrap;
}

.box1-2 span {
    display: inline-block;
}

.box1-3 {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.box2 {
    background: white;
    /*display: flex;*/
    margin: 10px 0;
    padding: 20px;
}


.box2-2 {
    flex: 1;
    padding: 10px;
    border-bottom: 1px solid #BBBBBB;
}

.box2-2>div {
    height: 30px;
    line-height: 30px;
}

.name {
    color: #101010;
    font-weight: bold;
}

.user {
    color: #101010;
}

.price {
    color: #EA0909 !important;
}

.price1 {
    color: #C5B9B9;
}

.num {
    float: right;
}

.red {
    color: #EA0909 !important;
}

.green {
    color: #3CC878 !important;
}

.codeBox {
    width: 120px;
    height: 120px;
}

.codeBody {
    display: flex;
    padding: 10px 10px 10px 10px;
    background: white;
    margin-top: 10px;
}

.num1Tip {
    font-size: 14px;
}

.num1 {
    color: red;
    font-size: 28px;
}

.num2 {
    font-size: 14px;
}

.p1 {
    padding: 5px 0;
}

.p1>span {
    padding: 0 10px;
}

.p2 {
    padding: 0 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 30px;
}

.p2>span {
    padding: 0 10px;
}

.bankIcon {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 4px;
}

.p3 {
    color: #BFB1B1;
    font-size: 14px;
    padding: 10px;
}

.p4 {
    display: inline-block;
    color: #EA0909;
    font-size: 14px;
    padding: 4px 10px;
    margin: 0 10px;
    font-weight: bold;
    white-space: nowrap;
}

.btns {
    text-align: center;
    margin-top: 100px;
}

.btn {
    width: 80%;
}

.tip {
    margin-top: 10px;
    padding: 10px 20px;
    color: #101010;
    background: white;
    font-weight: bold;
}

.refresh {
    color: #4B9DFD;
}

.qrCodeError {
    font-size: 14px;
    color: red;
    margin-top: 10px;
    padding: 10px 20px;
    background: white;
}

.partTitle {
    text-align: center;
    padding: 0 0 10px 0;
    font-size: 18px;
    font-weight: bold;
}

.partContent {
    padding: 20px 0;
}

.partBtns {
    display: flex;
    margin-bottom: -20px;
}

.partBtn {
    flex: 1;
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #ebedf0;
    border-right: 1px solid #ebedf0;
}

.partProup {
    width: 90%;
    padding: 20px 0;
}

.tip {
    font-size: 14px;
    color: #646566;
}

.btnsDiv {
    width: 90%;
    margin: 40px auto;
}

.black {
    color: black !important;
}
</style>
